module.exports = "<section _v-0396a9c4=\"\"><div class=\"sm-container text-center\" _v-0396a9c4=\"\"><h1 _v-0396a9c4=\"\">{{'DISCLAIMER_HEAD' | wordDict}}</h1><div class=text-left _v-0396a9c4=\"\">{{{'DISCLAIMER_CONTENT' | wordDict | markdown}}}</div></div></section>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-0396a9c4!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/component/disclaimer/disclaimer-page.vue
// module id = 358
// module chunks = 0